import { AutosaveFeedback } from "@/components/AutosaveFeedback"
import type { AutosaveStatus as AutosaveStatusValue } from "@/hooks/use-autosave"

export interface AutosaveStatusProps {
  status: AutosaveStatusValue
  save?: () => boolean
  discard?: () => boolean
  clear?: () => boolean
  clearDraft?: () => boolean
  className?: string
}

export function AutosaveStatus({
  status,
  save,
  discard,
  clearDraft,
  clear,
  className,
}: AutosaveStatusProps) {
  return (
    <AutosaveFeedback
      status={status}
      onSave={save}
      onDiscard={discard ?? clearDraft ?? clear}
      className={className}
    />
  )
}